/* eslint-disable react/no-deprecated */
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// import 'react-data-grid/lib/styles.css';
// import App from './App';
// import Signup from './components/controls/stlogin/Signup';
// import Logout from './components/controls/stlogout/Logout';
// import Backend from './components/controls/stlogin/Backend';
import { Route, Switch, BrowserRouter, Redirect } from "react-router-dom";
import { IMongoOption } from '@semtalk/mongodb';
import { SemTalkRole } from './components/ISemTalkOnline';
import { SemTalkCookie } from './components/ISemTalkCookie';
import { accessCookie, setCookie, setSubsitePrefix } from '@semtalk/cookies';
// import ConsentPopup from "./ConsentPopup";
// import ClosePopup from "./ClosePopup";
// import TabConfig from './TabConfig';
// import TermsOfUse from './TermsOfUse';
// import Privacy from './Privacy';
// import Tab from './Tab';
import config from './config';
import { initializeIcons } from '@fluentui/font-icons-mdl2';
import { registerIcons } from '@fluentui/style-utilities';
// import { Spinner } from '@fluentui/react';

registerIcons({
  icons: {
    PanelSize: '\uE8A4',
  },
  style: { fontFamily: 'FabricMDL2Assets' },
});
import { LoadingScreen } from './components/controls/stloading/LoadingScreen';
// import LoginDC from './loginDC';
import { getAppConfig } from './components/settings';

const App = React.lazy(
  () =>
    import(/* webpackChunkName: "semtalkapp" */ "./App")
);
const Tab = React.lazy(
  () =>
    import(/* webpackChunkName: "semtalktab" */ "./Tab")
);
const Signup = React.lazy(
  () =>
    import(/* webpackChunkName: "login" */ "./components/controls/stlogin/Signup")
);
const Logout = React.lazy(
  () =>
    import(/* webpackChunkName: "login" */ "./components/controls/stlogout/Logout")
);
const Backend = React.lazy(
  () =>
    import(/* webpackChunkName: "login" */ "./components/controls/stlogin/Backend")
);
const ConsentPopup = React.lazy(
  () =>
    import(/* webpackChunkName: "consentpopup" */ "./ConsentPopup")
);
const ClosePopup = React.lazy(
  () =>
    import(/* webpackChunkName: "closepopup" */ "./ClosePopup")
);
const TabConfig = React.lazy(
  () =>
    import(/* webpackChunkName: "tabconfig" */ "./TabConfig")
);
const TermsOfUse = React.lazy(
  () =>
    import(/* webpackChunkName: "termsofuse" */ "./TermsOfUse")
);
const Privacy = React.lazy(
  () =>
    import(/* webpackChunkName: "privacy" */ "./Privacy")
);
const LoginDC = React.lazy(
  () =>
    import(/* webpackChunkName: "logindc" */ "./loginDC")
);
const WebChat = React.lazy(
  () =>
    import(/* webpackChunkName: "webchat" */ "./Bot")
);
// Prefix der vor alle SemTalkCookies gesetzt wird um mehre Apps in derselben Site unterscheiden zu können
// => mehrere Webparts in der selben Site oder in mehreren Channels desselben Teams
if ((window as any).goto_context === undefined) {
  (window as any).goto_context = {
    url: "",
    model: "-1",
    page: "-1",
    obj: "-1",
    shp: "",
    callbacks: {},
    stay: false,
    exdays: 10,
    site: "",
    subsite: ""
  };
} else {
  console.log((window as any).goto_context);
}

async function init() {
  setSubsitePrefix("");
  // let showlogin: boolean = true;
  let usemongo: boolean = true;
  let usemongos = accessCookie(SemTalkCookie.usemongo);
  if (usemongos !== null) {
    usemongo = (usemongos !== "false");
  }

  let semmongoserverurl = accessCookie(SemTalkCookie.semmongoserverurl);
  if (semmongoserverurl === "http://localhost:7071/api/") {
    semmongoserverurl = config.apiEndpoint; // "/api/";
  }
  if (!semmongoserverurl) {
    semmongoserverurl = config.apiEndpoint;
  }
  let semmongoserverurlBackup = accessCookie(SemTalkCookie.semmongoserverurlBackup);
  semmongoserverurlBackup = config.apiBackupEndpoint;

  // semmongoserverurl = "http://localhost:7071/api/";
  // semmongoserverurl = "https://semmongo4.azurewebsites.net/api/";
  // semmongoserverurl = "http://localhost:3001/";

  setCookie(SemTalkCookie.semmongoserverurl, semmongoserverurl);

  const semmongologintokencookiename = "mongo_token";

  let semconnecttoken = accessCookie(SemTalkCookie.semconnecttoken);
  if (!semconnecttoken) semconnecttoken = "";

  // "mongodb://localhost:27017" test
  // semconnecttoken = "aef864f1cb11a4d5b9cd6421b56c113c7f7c9f17efeee15e1c03d3c67d55d6a832eb757e6e7a53cb9b1d54c74e73d291102e64b62818fb4cfd3feb6c6e76b12c54ef";
  //  "mongodb://ssss:xxxx%21@semtalkmongodb.westeurope.azurecontainer.io:27017"
  // semconnecttoken = "aef864f1cb11a4d5b9cd6421b56c113c7f7c9f17efeefe541216deda7b49cca853b9281b383414dada4e11e65f77cc8053782da8221be842f536aa75676cab2c03e05d3fc9e4b1798a869e7519643451e9687436cf07c154167985d81fb38a";

  // "mongodb+srv://ssss:xxxx!@cluster0.pumvg.mongodb.net/semtalkonline"
  // semconnecttoken = "aef864f1cb11a4d5b9cd6421b56c113c7f7c9f06b3b3fb0b504dcccb7f52c3e669b32b750a3d12bd9e104b950d52c298476732a03f45a15de439f2652c72b02711fd562d82a4b577d0879e7b026b2c5bef687d2d8f0b8c13"
  // semconnecttoken = "";

  // mongodb+srv://semtation:<password>@pck.dtukqxk.mongodb.net
  // semconnecttoken = "aef864f1cb11a4d5b9cd6421b56c113c7f7c9f06b3b3fb0b504dcccb7f52c3e669b32b752a3d129d9e104be65c71cada566033ae3c0de403fc3bea656d7bbd6718f7466dd1"

  // SemTalk Services Token mit SServices Admin Portal gemacht:
  // mongodb+srv://semtation:<password>@pck.dtukqxk.mongodb.net/semtalkonline_semtalk_com"
  // KHYEsllxU1c8bUy6KbbNAPFlXXufzBkRPEfBN7w0O+/OSyES4eZykj8pSeWbXGdhG6T/5i+2Zf88viLnVh3r3Tbp25iyzoIoeT+xGjePZYxO4G939bRNR7NuhIhQ6OUN

  // mongodb+srv://semtation:SemTalk3!@cluster2.kkbs7.mongodb.net/kibardoc
  // aef864f1cb11a4d5b9cd6421b56c113c7f7c9f06b3b3fb0b504dcccb7f52c3e669b32b750a3d12bd9e104b950d52c298476732a03f47a146fa36f7352c72b02711fd562d82a4b577d09f92741778245fe3246c
  setCookie(SemTalkCookie.semconnecttoken, semconnecttoken);

  let db = accessCookie(SemTalkCookie.dbname);
  if (!db) db = "semtalkonline";
  let re = accessCookie(SemTalkCookie.repository);
  if (!re) re = "repository";


  function setToken(userToken: any) {
    sessionStorage.setItem(semmongologintokencookiename, JSON.stringify(userToken));
  }

  function getToken() {
    const tokenString = sessionStorage.getItem(semmongologintokencookiename);
    if (tokenString) {
      const userToken = JSON.parse(tokenString);
      return userToken;
    }
  }
  const appConfig = await getAppConfig(semmongoserverurl, semconnecttoken, getToken());

  let semdocuments = appConfig.semtalkdocuments;
  let defdb = "semtalkonline";
  if (appConfig.portalmode || accessCookie(SemTalkCookie.portalmode) === "true") {
    semdocuments = appConfig.portallib;
    if (accessCookie(SemTalkCookie.portallib) && (accessCookie(SemTalkCookie.portallib).length > 0)) {
      semdocuments = accessCookie(SemTalkCookie.portallib);
    }
    db = appConfig.portaldb;
    defdb = appConfig.portaldb;
    if (accessCookie(SemTalkCookie.portaldb) && (accessCookie(SemTalkCookie.portaldb).length > 0)) {
      db = accessCookie(SemTalkCookie.portaldb);
      defdb = accessCookie(SemTalkCookie.portaldb);
    }
    semconnecttoken = appConfig.portalconnection;
    if (accessCookie(SemTalkCookie.portalconnection) && (accessCookie(SemTalkCookie.portalconnection).length > 0)) {
      semconnecttoken = accessCookie(SemTalkCookie.portalconnection);
    }
    usemongo = true;
  }


  let mongo: IMongoOption = {
    usemongo: usemongo,
    semmongoserverurl: semmongoserverurl,
    semmongoserverurlBackup: semmongoserverurlBackup,
    documents: semdocuments,
    backup: "SDX_backup",
    templates: "Templates",
    stencils: "Stencils",
    // approved: "Approved",
    approved: appConfig.semtalkapproved,
    semuserlogin: null,
    semmongoconnectiontoken: semconnecttoken,
    dbname: db,
    repository: re,
    iselectron: false,
    defaultdatabase: defdb,
    defaultrepository: "repository",
    objects: "Objects",
    roles: "Roles",
    users: "Users",
    vectorsearchindex: ""
  };
  let ro = accessCookie(SemTalkCookie.role);
  if (!ro) ro = SemTalkRole.editor;

  let url = document.baseURI;
  if (url.indexOf("?") > 0) {
    let args = url.substr(url.indexOf("?") + 1);
    for (let param of args.split("&")) {
      let p = param.split("=")[0];
      let v = decodeURI(param.split("=")[1]);
      switch (p) {
        case "iselectron": {
          mongo.iselectron = (v !== "false");
          // showlogin=false;
          break;
        }
        case "usemongo": {
          mongo.usemongo = (v !== "false");
          break;
        }
        case "share": {

          if (v.length > 0) {

            let b = Buffer.from(v, 'base64').toString('utf8');
            let shareParams = b.split(",");
            for (let s of shareParams) {
              let shareParam = s.split(":");
              if (shareParam[0].length > 0) {
                if (shareParam[0] === "db") mongo.dbname = shareParam[1];
                if (shareParam[0] === "server") mongo.semmongoconnectiontoken = shareParam[1];
                if (shareParam[0] === "role") ro = shareParam[1];
              }
            }
            // window.history.replaceState(null, "", "/");
          }
        }
      }
    }
  }

  if (mongo.iselectron && mongo.semmongoserverurl === config.apiEndpoint) {
    mongo.semmongoserverurl = appConfig.apiBackupEndpoint;
    setCookie(SemTalkCookie.semmongoserverurl, semmongoserverurl);
  }

  let suspfallback = <LoadingScreen backgroundColor="#f3f2f1" message='' />;

  if (!(window as any)["iconsInitialized"]) {
    initializeIcons(undefined, { disableWarnings: true });
    (window as any)["iconsInitialized"] = true;
  }


  if (mongo.iselectron) {
    ro = SemTalkRole.editor;
    const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
    root.render(
      <Suspense fallback={suspfallback}>
        <App setToken={setToken}
          getToken={getToken}
          mongo={mongo}
          semmongologintokencookiename={semmongologintokencookiename}
          role={ro}
          config={appConfig} /></Suspense>);
  } else {
    // let authstart = config.initiateLoginEndpoint;
    let authstart = "auth-start";
    if (document.location.href.toLowerCase().indexOf("auth-start") > 0) authstart = document.location.href;
    let authend = "/auth-end";
    if (document.location.href.toLowerCase().indexOf("auth-end") > 0) authend = document.location.href;

    const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
    root.render(
      <BrowserRouter>
        <Switch>
          <Route path="/tab">
            <Suspense fallback={suspfallback}>
              <Tab setToken={setToken}
                getToken={getToken}
                mongo={mongo}
                semmongologintokencookiename={semmongologintokencookiename}
                config={appConfig} />
            </Suspense>
          </Route>
          <Route path="/privacy">
            <Suspense fallback={suspfallback}>
              <Privacy />
            </Suspense>
          </Route>
          <Route path="/termsofuse">
            <Suspense fallback={suspfallback}>
              <TermsOfUse />
            </Suspense>
          </Route>
          <Route path="/home">
            <Redirect to={{ pathname: "https://semtalk.com" }} />
          </Route>
          <Route path="/config">
            <Suspense fallback={suspfallback}>
              <TabConfig
                config={appConfig} />
            </Suspense>
          </Route>
          <Route path={authstart}>
            <Suspense fallback={suspfallback}>
              <ConsentPopup />
            </Suspense>
          </Route>
          <Route path={authend}>
            <Suspense fallback={suspfallback}>
              <ClosePopup />
            </Suspense>
          </Route>
          <Route path="/logout">
            <Suspense fallback={suspfallback}>
              <Logout semmongologintokencookiename={semmongologintokencookiename} />
            </Suspense>
          </Route>
          <Route path="/signup">
            <Suspense fallback={suspfallback}>
              <Signup mongo={mongo} setToken={setToken} />
            </Suspense>
          </Route>
          {/* <Route path="/updatepassword" exact> <UpdatePassword mongo={mongo} setToken={setToken} /></Route> */}
          {/* <Route path="/forgotpassword" exact> <ForgotPassword mongo={mongo} setToken={setToken} /></Route> */}
          {/* <Route path="/forgotpasswordverify"> <ForgotPasswordVerify mongo={mongo} setToken={setToken} /></Route> */}
          {/* <Route path="/clonedb" exact> <CloneDatabase mongo={mongo}  header={true}/></Route> */}
          {/* <Route path="/options" exact> <Options mongo={mongo} /></Route> */}
          <Route path="/backend" exact>
            <Suspense fallback={suspfallback}>
              <Backend mongo={mongo} />
            </Suspense>
          </Route>
          <Route path="/logindc" exact>
            <Suspense fallback={suspfallback}>
              <LoginDC
                setToken={setToken}
                getToken={getToken}
                mongo={mongo}
                semmongologintokencookiename={semmongologintokencookiename}
                context={undefined}
                theme={"default"}
                config={appConfig} />
            </Suspense>
          </Route>
          <Route path="/bot">
            <Suspense fallback={suspfallback}>
              <WebChat />
            </Suspense>
          </Route>
          <Route path="/">
            {document.location.hash === "#/tab" &&
              <Suspense fallback={suspfallback}>
                <Tab setToken={setToken}
                  getToken={getToken}
                  mongo={mongo}
                  semmongologintokencookiename={semmongologintokencookiename}
                  config={appConfig}></Tab>
              </Suspense>}
            {document.location.hash === "#/config" &&
              <Suspense fallback={suspfallback}>
                <TabConfig
                  config={appConfig}
                />
              </Suspense>}
            {document.location.hash !== "#/tab" && document.location.hash !== "#/config" &&
              <Suspense fallback={suspfallback}>
                <App setToken={setToken}
                  getToken={getToken}
                  mongo={mongo}
                  semmongologintokencookiename={semmongologintokencookiename}
                  role={ro}
                  config={appConfig} />
              </Suspense>
            }
          </Route>
        </Switch>
      </BrowserRouter>);
  }
}
init();